import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import PrintAgentGuideButton from "./GuideButton";
import PurchaseCTA from "./PurchaseCTA";
import { TabFormSection } from "./PurchaseLayouts";
import PurchaseOption from "./PurchaseOption";
const AddToCartTab = (param)=>{
    let { onClick , isHandoutCoupons , onCouponClick  } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(TabFormSection, {
                sx: {
                    py: 2.5
                },
                title: "구매옵션 선택",
                children: [
                    /*#__PURE__*/ _jsx(Stack, {
                        direction: "row",
                        spacing: 1,
                        sx: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ _jsx(PurchaseOption, {})
                    }),
                    /*#__PURE__*/ _jsx(PrintAgentGuideButton, {})
                ]
            }),
            /*#__PURE__*/ _jsx(PurchaseCTA, {
                variant: "total",
                onClick: onClick,
                isHandoutCoupons: isHandoutCoupons,
                onCouponClick: onCouponClick
            })
        ]
    });
};
export default AddToCartTab;
